import Vue from 'vue';
//import 'promise-polyfill/src/polyfill';
import Thumb from './components/Thumb'
import Category from './components/Category'
import SearchForm from './components/SearchForm'
import ReportForm from './components/ReportForm'
import Lang from './components/Lang'
import Tags from './components/Tags'
import Paginator from './components/Paginator'
import VdaLink from './components/VdaLink'
import VideoEmbed from './components/VideoEmbed'
import Sort from './components/Sort'
import Network from './components/Network'
import Hardlink from './components/Hardlink'

import cjer from './helpers/cjer'
import config from '../../config.json'


import lazyLoad from './directives/lazyLoad.js'

window.cjer = cjer;

window.tq = {};
window.position = window.position || 0;

Vue.prototype.$cjer = cjer;

Vue.directive('lazy', lazyLoad);

const $app = new Vue({
  el: '#app',
  data: {
    isSearchOpen: false,
    isNavOpen: false,
    width: window.innerWidth,
    isMobile: window.innerWidth >= 1024 ? false : true,
    isPhone: (() => {
      return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4)) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
    })(),
    isTablet: (() => {
      return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    })(),
    state: {
      lang: window.lang
    },
    config: config,
    hardlink: []
  },  
  components: {
    VideoEmbed,
    Network,
    Thumb,
    Category,
    Lang,
    SearchForm,
    Tags,
    ReportForm,
    Paginator,
    Sort,
    Hardlink,
    VdaLink
  },
  methods: {
    handleWindowResize() {
      this.width = window.innerWidth;
      this.isMobile = window.innerWidth < 1024 ? true : false;
    },
    openSearch() {
      this.isSearchOpen = true;
    },
    burgerHandler() {
      if(this.isSearchOpen) return this.isSearchOpen = false;
      this.isNavOpen ? this.closeNav() : this.openNav();
    },
    openNav() {
      this.isNavOpen = true;
      document.body.classList.add('is-nav');
    },
    closeNav() {
      this.isNavOpen = false;
      document.body.classList.remove('is-nav');
    },
    videoMore() {
      this.$refs.text.classList.toggle('video__text--active')
      console.log(this.$refs);
    },
    hardlinkLoader(data) {
      this.hardlink = this.hardlink.concat(data);
    },
  },
  watch: {
    isNavOpen: function(val) {
      console.log(31231231)
    }
  },
  computed: {
    langs() {
      let l = {...this.config.langs};
      delete l[window.lang];
      return l;
    },
    hlink() {
      return this.hardlink;
    }
  },
  mounted() {

    document.dispatchEvent(new Event('build'));
    window.addEventListener('resize', this.handleWindowResize);

    const loader = this.hardlinkLoader.bind(this);
    document.dispatchEvent(new CustomEvent('loadHardlink', { detail: { hardlinkLoader:loader }}));

    
  },
  created() {
    this.$cjer.utmObject();
    
    let activeNav = document.querySelector(`.header a[href="${location.pathname}"]`);
    if(!activeNav) return;
    activeNav.parentElement.classList.add('nav__item--active');

    
  }
  

})


import axios from 'axios';

window.$app = $app;

var options = {
  root: null,
  rootMargin: '50px',
  //threshold: 0.1
};


var targets = document.querySelectorAll('[data-lazy]');
var lazyLoadNative = target => {

  var io = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      
      if (entry.isIntersecting) {
        var img = entry.target;
        var src = img.dataset.lazy;
        img.setAttribute('style', `background-image:url('${src}')`);
        observer.disconnect();
      }
    });
  }, options);

  io.observe(target)

};


function loadImages() {
  if(typeof IntersectionObserver === "undefined") {
    for (let i = 0; i < targets.length; i++) {
      var item = targets[i];
      var src = item.dataset.lazy;
      item.setAttribute('style', `background-image:url('${src}')`);
    }
    return;
  }
  
  targets.forEach(lazyLoadNative);
}

loadImages()


setInterval(() => {
  if(Object.keys(window.tq).length > 0) {

    let form_data = new FormData();
    for ( var key in window.tq ) {
        form_data.append(key, window.tq[key]);
    }
    //axios.post('/l.php', window.tq);
    axios({
      method: 'post',
      url: '/l.php',
      data: form_data,
      headers: {'Content-Type': 'multipart/form-data' }
    });
    window.tq = {};
  }
}, 1000);


